export const HEADER_TRY_NOW = {
    caseName: "TRYNOW",
    header: "Dedicated team for the American try-before-you-buy e-commerce project",
    duration: "3 years",
    industry: "e-commerce",
    location: "USA",
    team: "20+ (5 Ukrainian members)",
}

export const HEADER_ORBIT = {
    caseName: "Orbit",
    header: "Dedicated team for the American Recruitment Agency",
    duration: "6 months",
    industry: "recruitment",
    location: "USA",
    team: "20 (5 Ukrainian members)",
}

export const HEADER_GAMETECH = {
    caseName: "gametech",
    header: "Extended team for global online gambling software and operations company",
    duration: "1.5 years",
    industry: "Gambling Facilities and Casinos",
    location: "UK",
    team: "10 (3 Ukrainian members)",
}

export const HEADER_QUARKWORKS = {
    header: "Building a long-term trusting & stable cooperation with Quarkworks",
    duration: "3 years",
    location: "USA",
    team: "30 (7 Ukrainian members)",
}

export const HEADER_HELLO = {
    caseName: "hello",
    header: "Extended team for the project of ex-Google Engineers ",
    duration: "1.5 years",
    industry: "Social Network",
    location: "USA",
    team: "5 (2 Ukrainian members)",
}

export const HEADER_CRAFT = {
    caseName: "craft",
    header: "Extended team for a SaaS analytics platform ",
    duration: "1.5 years",
    industry: "Financial Service",
    location: "USA",
    team: "25 (4 Ukrainian members)",
}

export const HEADER_PEDNET = {
    caseName: "pednet",
    header: "PedNet | project for improving  the Well-being of Colombian Residents",
    duration: "1 year",
    industry: "Environmental solutions",
    location: "USA",
    team: "3 Ukrainian members",
}
